module.exports = __webpack_public_path__ + "assets/language-squares/ja-1b08a9a60c363ef5f41ccd650692a088.jpg";